
export default {
  fr: {},
  en: {},
}
